export default "Shealyn: where are you?\nAlex: running 5 mins late, sorry\nShealyn: no worries, I just got here\nAlex: ok see you soon\n"